import 'sticky-kit/dist/sticky-kit';
import './base/';
import './base/btn-toggle';
import './base/read-more';
import './base/accordions';
import './base/mobile-nav';
import './base/product';
import './base/ajax-add-btn';
import './base/fixed-nav';
import './base/ajax-add-btn';
import './base/faq-page';
import './base/overflow-product-section';
import './base/products-overlay';
import './base/scroll-to-target';
import './base/triple-images';
import './base/magnific';
import './base/popup-fit-guide';
import { setCookie, getCookie, eraseCookie } from './base/cookies';
import { introParallax, initSkrollrParallax } from './base/parallax';
import { scrollSpy } from './base/scroll-spy';
import animateScroll from './base/animate-scroll';
import './sliders/product-images';
import './base/add-cross-sell-product-in-cart';
import './sliders/sliders';
import './base/swatches';
import './base/mailchimp';

const $win = $(window);
const $doc = $(document);
const cookieActive = getCookie('_subs_form');
let pdpSecondImageScrolled = false;

ifInternetExplorer();

$win.on('load', function () {
  setTimeout(function () {
    callPopup();
  }, 10000);

  if ($('.template-index').length || $('.template-page--secret').length) {
    const $introSections = $('.intro');

    if ($introSections.length > 1) {
      $introSections.each(function (index) {
        const $this = $(this);

        if (index !== 0) {
          $this
            .find('.js-parallax')
            .removeClass('js-parallax')
            .css('transform', 'none');
        }
      });
    }
  }
});

$(window).on('load', function () {
  scrollSpy();
});

$(window).on('load scroll', function () {
  if ($('.js-spy-nav').length) {
    const winScrollTop1 = $(window).scrollTop() + 700;
    const test1 = $('.will-scroll-here').offset().top;

    if (winScrollTop1 >= test1) {
      $('.js-spy-nav').addClass('hide');
    } else {
      $('.js-spy-nav').removeClass('hide');
    }
  }
});

$('.js-section-product').on('scroll', function () {
  scrollSpy();
});

$('.section__content .scroll-placeholder').on('mouseenter', function () {
  if (!pdpSecondImageScrolled) {
    pdpSecondImageScrolled = true;

    const $productSecondImage = $(
      '.section__images .product-image:nth-child(2)'
    );
    animateScroll($productSecondImage);
  }
});

function callPopup() {
  const $htmlGlobal = $('html');
  const $subscribePopup = $('.js-popup-subscribe');
  const $closeCookie = $('.js-close-cookie');
  const $submitCookie = $('.js-submit-btn');

  if (!cookieActive) {
    $subscribePopup.addClass('expanded');
    $htmlGlobal.addClass('stop-movement');
  }

  $closeCookie.on('click', function (e) {
    e.preventDefault();
    setCookie('_subs_form', 'email', 3);
    $htmlGlobal.removeClass('stop-movement');
  });

  $submitCookie.on('click', function () {
    setCookie('_subs_form', 'email', 3);
    $htmlGlobal.removeClass('stop-movement');
  });
}

function ifInternetExplorer() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    if ($('.js-sticky').length) {
      $('.js-sticky').stick_in_parent({
        offset_top: 40,
      });
    }
  } else {
    return false;
  }
}

var isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);

if (isMacLike) {
  if ($('.js-section-product').length) {
    $('.js-section-product').addClass('is-on-ios');
  }
}
